/* eslint-disable no-unreachable */
import { config } from '../utils/constants/api.constants';
import { parseFulfillmentDetails } from '../utils/parsers/fastagFulfilment';
import { convertObjectToParams, parseFastagErrResponse } from '../utils/utils';

const {
  baseUrl,
  fastagOrders,
  fastagFulfilmentOrders,
  viewFile,
  fastagFulfilmentFile,
  fastagFulfilmentConfig,
  updateKyc,
  activateFastagOrder,
  fastagFulfilmentDetails,
} = config.api.fastagD2c;

export default (api) => {
  const getFastagOrders = (params = {}) => {
    const url = `${baseUrl}${fastagOrders}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  const getFastagFulfilmentOrders = ({ params }) => {
    const url = `${baseUrl}${fastagFulfilmentOrders}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  const getFastagFulfilmentDetails = ({ params }) => {
    const url = `${baseUrl}${fastagFulfilmentDetails}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((resp) => {
          resolve(parseFulfillmentDetails(resp.data));
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  const getDocumentDetails = ({ params }) => {
    const url = `${baseUrl}${viewFile}${convertObjectToParams(params)}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  const uploadFastagFulfilmentDocument = ({ params, payload }) => {
    const url = `${baseUrl}${fastagFulfilmentFile}${convertObjectToParams(
      params
    )}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, payload)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  const getFastagFulfilmentConfig = () => {
    const url = `${baseUrl}${fastagFulfilmentConfig}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  const updateFastagFulfilmentData = ({ payload }) => {
    const url = `${baseUrl}${updateKyc}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, payload)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  const activateFastag = ({ payload }) => {
    const url = `${baseUrl}${activateFastagOrder}`;
    return new Promise((resolve, reject) => {
      api
        .put(url, payload)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(parseFastagErrResponse(error));
        });
    });
  };

  return {
    getFastagOrders,
    getFastagFulfilmentOrders,
    getFastagFulfilmentDetails,
    getDocumentDetails,
    uploadFastagFulfilmentDocument,
    getFastagFulfilmentConfig,
    updateFastagFulfilmentData,
    activateFastag,
  };
};
